module.exports = __webpack_public_path__ + "static/media/screenshot-9.9797611b.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/screenshot-9.png
// module id = 694
// module chunks = 2